import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { api } from 'api/config';

const AuthenticatedImage = ({ src, alt, ...props }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Extract the path — handle both absolute and relative URLs
        // new URL() requires an absolute URL, so supply window.location.origin as base.
        // Keep url.search: endpoints like /gallery/thumb pass the file as a query param.
        const url = new URL(src, window.location.origin);
        const apiPath = url.pathname.replace('/api', '') + url.search; // Remove /api prefix
        
        // Create API instance for image fetching
        const imageApi = api();
        
        const response = await imageApi.get(apiPath, {
          responseType: 'blob',
        });
        
        // Create object URL for the blob
        const objectUrl = URL.createObjectURL(response.data);
        setImageSrc(objectUrl);
        
      } catch (err) {
        console.error('Error fetching authenticated image:', err);
        setError('Failed to load image');
      } finally {
        setLoading(false);
      }
    };

    if (src) {
      fetchImage();
    }
  }, [src]);

  // Separate useEffect for cleanup
  useEffect(() => {
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [imageSrc]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100px">
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ minHeight: '100px' }}>
        {error}
      </Alert>
    );
  }

  return (
    <img 
      src={imageSrc} 
      alt={alt} 
      {...props}
      style={{
        maxWidth: '100%',
        height: 'auto',
        ...props.style
      }}
    />
  );
};

export default AuthenticatedImage;